import { IconComponentConfig } from '../icon/icon-component-config.interface';
import { TextComponentConfig } from '../text';

export interface Address {
  content: TextComponentConfig;
  icon?: IconComponentConfig;
}
